import React from "react";
import $ from "jquery";
import "./company.css";
import { imgSrc } from "../../../modules";

class CompanyComponent extends React.Component {
    state = {
        visible: false,
    };

    dragable = () => {
        let clicked = false;
        let clickX = 0;

        const updateScrollPos = (e) => {
            $("#scrolling").scrollLeft($("#scrolling").scrollLeft() + (clickX - e.offsetX));
        };

        $("#scrolling").on({
            mousemove: (e) => {
                clicked && updateScrollPos(e);
            },
            mousedown: (e) => {
                e.preventDefault();
                clicked = true;
                clickX = e.offsetX;
            },
            mouseup: () => {
                clicked = false;
            },
            mouseout: () => {
                clicked = false;
            },
        });
    };

    listingButton = () => {
        let intervalRight, intervalLeft;

        $("#scrollLeft").on({
            mousedown: (e) => {
                e.preventDefault();
                intervalLeft = setInterval(() => {
                    if ($("#scrolling").scrollLeft() > 0) {
                        $("#scrolling").scrollLeft($("#scrolling").scrollLeft() - 3);
                    }
                }, 3);
            },
            mouseup: (e) => {
                e.preventDefault();
                clearInterval(intervalLeft);
            },
        });

        $("#scrollRight").on({
            mousedown: (e) => {
                e.preventDefault();
                intervalRight = setInterval(() => {
                    if ($("#scrolling>div").width() > $("#scrolling").scrollLeft()) {
                        $("#scrolling").scrollLeft($("#scrolling").scrollLeft() + 3);
                    }
                }, 3);
            },
            mouseup: (e) => {
                e.preventDefault();
                clearInterval(intervalRight);
            },
        });
    };

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    handleOk = (e) => {
        this.setState({
            visible: false,
        });
    };

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    };

    componentDidMount = () => {
        this.dragable();
        this.listingButton();
        if ($("#scrolling>div").width() > $("#scrolling").scrollLeft()) {
            let scLeft;
            const interval = setInterval(() => {
                scLeft = $("#scrolling").scrollLeft() + 1;
                $("#scrolling").scrollLeft(scLeft);
                if (scLeft > $("#scrolling").scrollLeft()) {
                    clearInterval(interval);
                }
            }, 100);
        }
    };

    render() {
        return (
            <div id="company">
                <div className="container">
                    <img src={imgSrc("cpn-logo-fullname.png", false)} id="logo-cpn" alt="บริษัท ซีพีเอ็น ทรานสปอร์ต จำกัด " />
                    <h2>ยินดีต้อนรับทุกท่าน</h2>
                    <p>เข้าสู่เว็บไซต์ของ บริษัท ซีพีเอ็น ทรานสปอร์ต จำกัด</p>
                    <p>บริษัท ซีพีเอ็น ทรานสปอร์ต จำกัด ให้บริการขนส่งสินค้า อุปโภค บริโภค เวชภัณฑ์และสินค้าพิเศษต่าง ๆ ด้วยรถขนส่งควบคุมอุณหภูมิพิเศษ ตลอดการจัดส่งสินค้า เป็นเวลา 22 ปี ตลอดระยะเวลาที่ผ่านมา บริษัทเราเห็นถึงความสำคัญในการพัฒนาประสิทธิภาพการให้บริการด้านขนส่ง เพื่ออำนวยประโยชน์สูงสุดให้กับลูกค้า และผู้บริโภค เราจึงได้จัดตั้งให้มีศูนย์กระจายสินค้าของบริษัทไปยังส่วนภูมิภาคต่าง ๆ ทั่วประเทศ ทุกตำบล </p>
                    <div className="wrap-vdo">
                        <iframe width="100%" height="450" src="https://www.youtube.com/embed/2o0uT-IL8SE" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                        <p>ความภูมิใจขององค์กรที่ได้เป็นผู้กระจายวัคซีนป้องกัน COVID-19 ชุดแรกของประเทศไทยตามโรงพยาบาลให้กับ DKSH</p>
                    </div>
                    <div id="company-service">
                        <div>
                            <h3>ระบบการจัดส่งสินค้า TMS (Transport Management System)</h3>
                            <p>ระบบการจัดส่งสินค้าโดยระบบ TMS กับการพัฒนารูปแบบการให้บริการจัดส่งสินค้า ด้วยการบันทึกขัอมูลการจัดส่งลงในอุปกรณ์ TMS เพื่อให้เกิดความปลอดภัยสูงสุดแก่ลูกค้า และเพิ่มขีดความสามารถในการบริหารจัดการข้อมูลได้เป็นอย่างดี</p>
                        </div>
                        <div>
                            <h3>ระบบติดตามยานพาหนะ GPS</h3>
                            <p>ระบบติดตามยานพาหนะ GPS กับมาตรฐานการให้บริการจัดส่งสินค้าด้วยการติดตามสถานะของรถบรรทุกตลอด 24 ชม. เพื่อให้ความมั่นใจต่อลูกค้าผู้ใช้บริการว่า สินค้าทุกชิ้นถูกจัดส่งภายใต้ระบบคุณภาพและการเฝ้าระวังตลอดระยะเวลาการจัดส่งสินค้าจะส่งถึงผู้รับปลายทางในสภาพที่สมบูรณ์ ปลอดภัย ตรงเวลา และคงมตรฐานของสินค้า ทั้งนี้เพื่อสร้างความพึงพอใจให้กับผู้ส่ง และผู้รับสินค้า ในการใช้บริการ</p>
                        </div>
                    </div>
                    <div id="company-vdo">
                        <div>
                            <h3>วิดีโอขั้นตอนการทำงาน</h3>
                            <div>
                                <iframe width="560" title="วิดีโอขั้นตอนการทำงาน" height="315" src="https://www.youtube.com/embed/h6zyynvaPO8" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                        </div>
                        <div>
                            <h3>อบรมประจำปี</h3>
                            <div>
                                <iframe width="560" title="อบรมประจำปี" height="315" src="https://www.youtube.com/embed/JOiMC1qArWM" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CompanyComponent;
